import { useEffect, useState } from "react";

export default function useChangingDebounce<T>(value: T, delay: number): [T, boolean] {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [changing, setChanging] = useState(false);
  const [waiting, setWaiting] = useState(false);
  useEffect(() => {
    if (changing) {
      setWaiting(true);
    } else {
      setDebouncedValue(value);
    }
    setChanging(true);
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      setChanging(false);
      setWaiting(false);
    }, delay);

    return (): void => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return [debouncedValue, waiting];
}
